import { Stack, Typography } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { useContext } from 'react';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PastYearsDocumentAccordion } from './PastYearsDocumentAccordion';

export const PastYearsDocuments = () => {
  const { previousYears } = useContext(DocumentsContext);

  return (
    <Stack gap='16px'>
      <Typography variant='h6'>
        {Dictionary[DICTIONARY.Documents].previousYears}
      </Typography>
      <Stack>
        {previousYears.map((year: number, index: number) => {
          return (
            <PastYearsDocumentAccordion key={index} time={year.toString()} />
          );
        })}
      </Stack>
    </Stack>
  );
};
